module.exports = __webpack_public_path__ + "img/bars-staggered.c984d256.svg";